var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 5.77501e-05H1.125C0.830039 -0.0029441 0.545934 0.111188 0.335024 0.317411C0.124114 0.523635 0.00362641 0.805104 0 1.10006V14.1526C0.00428223 14.4471 0.125058 14.7279 0.335896 14.9336C0.546735 15.1393 0.830466 15.2531 1.125 15.2501H14.125C14.42 15.2524 14.7039 15.1379 14.9147 14.9315C15.1255 14.7252 15.246 14.4438 15.25 14.1488V1.09631C15.2447 0.802219 15.1236 0.522091 14.913 0.316815C14.7023 0.111538 14.4191 -0.00229496 14.125 5.77501e-05Z",
    fill: "#0076B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25715 5.71631H4.5209V13.0001H2.25715V5.71631ZM3.38965 2.09131C3.64929 2.09131 3.9031 2.16832 4.11896 2.31259C4.33483 2.45687 4.50306 2.66192 4.60236 2.90183C4.70166 3.14173 4.72758 3.40569 4.67684 3.66032C4.62609 3.91496 4.50096 4.14882 4.31728 4.33233C4.1336 4.51583 3.89962 4.64074 3.64494 4.69124C3.39026 4.74174 3.12632 4.71557 2.88651 4.61604C2.6467 4.51651 2.44181 4.34809 2.29774 4.13208C2.15367 3.91608 2.0769 3.6622 2.07715 3.40256C2.07748 3.05468 2.21591 2.72116 2.46201 2.47529C2.70812 2.22942 3.04177 2.09131 3.38965 2.09131ZM5.9409 5.71631H8.1109V6.71631H8.1409C8.4434 6.14381 9.1809 5.54006 10.2821 5.54006C12.5746 5.53506 12.9996 7.04381 12.9996 9.00006V13.0001H10.7359V9.45631C10.7359 8.61256 10.7209 7.52631 9.55965 7.52631C8.3984 7.52631 8.2009 8.44631 8.2009 9.40131V13.0001H5.9409V5.71631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.59c38022934dcec31033480c7ff5e854.svg";
export { ForwardRef as ReactComponent };